import _createClass from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
export var TopicStats = /*#__PURE__*/_createClass(function TopicStats(stats) {
  _classCallCheck(this, TopicStats);

  _defineProperty(this, "quantityRemaining", void 0);

  _defineProperty(this, "quantitySold", void 0);

  _defineProperty(this, "viewerCount", void 0);

  _defineProperty(this, "viewerEffect", void 0);

  this.quantityRemaining = (stats === null || stats === void 0 ? void 0 : stats.quantityRemaining) || null;
  this.quantitySold = (stats === null || stats === void 0 ? void 0 : stats.quantitySold) || null;
  this.viewerCount = (stats === null || stats === void 0 ? void 0 : stats.viewerCount) || null;
  this.viewerEffect = (stats === null || stats === void 0 ? void 0 : stats.viewerEffect) || null;
});